/**
 *
 * Support
 *
 */

import React from "react"

import "./index.less"
import Processes from "./Processes"
import RecordProcesses from "./RecordProcesses"
import { Helmet } from "react-helmet"
import { map, includes, flatMap, find } from "lodash"
const optionsGeneral = [
  { name: "Procesos", slug: "processes" },
  { name: "Historial", slug: "record" }
]


/* eslint-disable react/prefer-stateless-function */
export class SupportPanel extends React.Component {
  componentDidUpdate(prevProps) {
    const { history } = this.props
    const { hash: hashPrev } = prevProps.location
    const { hash, pathname } = location

    if (hashPrev && hash) {
      if (hashPrev !== hash) {
        const url = pathname
        history.push(`${url}${hash}`)
      }
    }
   
  }

  optionActive = (slugName) => {
    let isActive = ""
    const onlySlugs = flatMap(optionsGeneral, (item) => `#${item.slug}`)
    let hashSelected = location.hash


    if (includes([...onlySlugs], hashSelected)) {
      isActive =
        (hashSelected || "#processes") === `#${slugName}`
          ? "container-supportpanel__left-body-option--active"
          : ""
    } else {
      window.location.hash = "processes"
    }

    return isActive
  }

  renderContent = () => {
    if (includes(["#processes", ""], location.hash)) {
     return <Processes />
    }

    if (location.hash === "#record") {
      return <RecordProcesses {...this.props} />
    }

    return <div>No page!</div>
  }

  viewComponent = () => {
    const name = find(
      [
        ...optionsGeneral,
      ],
      (item) => {
        return `#${item.slug}` === (location.hash || "#processes")
      }
    )
    const shouldAddPadding =
    typeof window.Intercom !== "undefined" &&
        window.self === window.top;
    console.log("shouldAddPadding", shouldAddPadding)
    const style = {
      height: "calc(100% - 74px)",
      paddingBottom: "63px" 
    };
    return (
      <div>
        <div className="container-supportpanel__right-title">
          {name && name.name}
        </div>
        <div
          className="container-supportpanel__right-content"
          style={style}>
          {this.renderContent()}
        </div>
      </div>
    )
  }



  renderContainer = () => {
    let response = this.viewComponent()
    return response
  }

  render() {

    return (
      <div>
        <Helmet>
          <title>Soporte</title>
          <meta name="description" content="Description of SupportPanel" />
        </Helmet>
      <div className="container-supportpanel">
          <div className="container-supportpanel__left">
            <div className="container-supportpanel__left-title">SOPORTE</div>
            <div className="container-supportpanel__left-body">
              {map(optionsGeneral, ({ name, slug }) => {
                return (
                  <div
                    onClick={() => (window.location.hash = slug)}
                    className={`container-supportpanel__left-body-option ${this.optionActive(
                      slug
                    )}`}
                    key={slug}>
                    {name}
                  </div>
                )
              })}
            </div>
          </div>
          <div className="container-supportpanel__right">
            {this.renderContainer()}
          </div>
        </div>
      </div>
    )
  }
}

 SupportPanel.propTypes = { }




export default SupportPanel;
